export enum LocalStorageItems {
  patientUserId = "patient-user-id",
  hasCompletedTwoFactorAuthenticationAtLogin = "has-completed-two-factor-authenticated-at-login",
  defaultChartGroupId = "default-chart-group-id",
  defaultPatientConnectClinicId = "default-patient-connect-clinic-id",
  jwt = "jwt",
}
